import { useCallback } from 'react'
import { useTranslations } from 'next-intl'

import type { OcppTagEntityType, OcppTagType, TransactionRateType } from '../types/transaction'

type StopReason = 'PowerLoss' | 'EVDisconnected' | 'HardReset'
const stopReasons: StopReason[] = ['PowerLoss', 'EVDisconnected', 'HardReset']

function isStopReason(reason?: string): reason is StopReason {
  return !!reason && stopReasons.includes(reason as StopReason)
}

/**
 * TODO: This will not work in general. The stop reason is not an enumerable value, so we cannot
 * possibly translate all possible values. This should be treated as a codeword and left
 * untranslated, but for the time being we are running the values through the translation
 * function to avoid breaking changes.
 */
export function useTransactionStopReasonFormatter() {
  const t = useTranslations('data.transactions')
  return useCallback((reason?: string) => (isStopReason(reason) ? t(`stopReason_${reason}`) : reason), [t])
}

type StopActor = 'station' | 'manual'
const stopActors: StopActor[] = ['station', 'manual']

function isStopActor(actor?: string): actor is StopActor {
  return !!actor && stopActors.includes(actor as StopActor)
}

export function useTransactionStopActorFormatter() {
  const t = useTranslations('data.transactions')
  return useCallback((actor?: string) => (isStopActor(actor) ? t(`stopActor_${actor}`) : actor), [t])
}

export function useTransactionRateTypeFormatter() {
  const t = useTranslations('data.transactions')
  return useCallback((rateType: TransactionRateType) => t(`rateType_${rateType}`), [t])
}

export function useAuthTagEntityTypeFormatter() {
  const t = useTranslations('data.transactions')
  return useCallback((entityType: OcppTagEntityType) => t(`ocppTagEntityType_${entityType}`), [t])
}

export function useAuthTagTypeFormatter() {
  const t = useTranslations('data.transactions')
  return useCallback((ocppTagType: OcppTagType) => t(`ocppTagType_${ocppTagType}`), [t])
}
